import api from '@/lib/hippo'
import JwtDecode from 'jwt-decode'
import Vue from 'vue'
import moment from 'moment';
import User from '@/models/user'
import Setting from '@/models/setting';
import i18n from '../i18n';

function initialState() {
    return {
        token: localStorage.getItem('api_token_client') || '',
        user: {},
        locale: 'en'
    };
}

const state = initialState;

const getters = {
    apiToken: (state, getters) => (getters.isLoggedIn)?state.token:null,
    isLoggedIn(state) {
        if (!!state.token) {
            const { exp } = JwtDecode(state.token);
            if ( exp > moment().unix() ) return true;
        }

        // Wipe token if exists;
        localStorage.removeItem('api_token_client');
        state.token = '';
        return false;
    },
    currentUserId(state) {
        if (!!state.token) {
            const { sub } = JwtDecode(state.token);
            return sub;
        }
        return null;
    },
    user: (state, getters) => state.user[getters.currentUserId]
};

const actions = {
    login ({ commit, getters }, {email, password, locale} ) {
      return new Promise((resolve, reject) => {
          api.login(email, password, locale)
             .then((response) => {
                 if (response.data && response.data.jwt) {
                     const { exp, account_type } = JwtDecode(response.data.jwt);
                     if (account_type == 'client') {
                         commit('setToken', response.data.jwt);
                         resolve(true);
                    } else {
                        commit('setToken', '');
                        reject(new Error('Your account does not have access to this system.'));
                    }
                 } else {
                     commit('setToken', '');
                     reject(new Error('Unrecognized Server Response'));
                 }
             }).catch( (err) => {
                 commit('setToken', '');
                 reject(err);
             });
      });
    },
    refreshToken ({getters, commit}) {
        return new Promise((resolve, reject) => {
            api.refreshToken(getters.apiToken)
                .then( (response) => {
                    if (response.data && response.data.data && response.data.data.attributes &&  response.data.data.attributes.value) {
                        commit('setToken', response.data.data.attributes.value);
                        resolve(true);
                    } else reject( new Error('Unrecognized Server Response') );
                }).catch( (err) => { reject(err) });
          });
    },
    currentUser ({getters, commit}) {
        return new Promise((resolve, reject) => {
            api.getUserProfile(getters.apiToken)
                .then( (response) => {
                    commit('setCurrentUser', User.from(response.data));
                    resolve(true);
                }).catch((err) => { reject(err) });
          });
    },
    saveUserProfile ({getters, commit, dispatch}, profile) {
        return new Promise((resolve, reject) => {
            api.putUserProfile(getters.apiToken, profile)
                .then( (response) => {
                    dispatch('currentUser');
                    resolve(true);
                }).catch((err) => { reject(err) });
          });
    },
    fetchLocale ({getters, commit}) {
        return new Promise((resolve, reject) => {
            api.getUserSetting(getters.apiToken, 'user:locale')
                .then( (response) => {
                    let setting = Setting.from(response.data);
                    i18n.locale = setting['user:locale'].value;
                    commit('setLocale', setting['user:locale'].value);
                    resolve(true);
                }).catch((err) => { reject(err) });
          });
    },
    changeLocale ({getters, commit}, locale) {
        return new Promise((resolve, reject) => {
            if (getters.apiToken) {
                api.putUserSetting(getters.apiToken, 'user:locale', locale)
                    .then((response) => {
                        i18n.locale = locale;
                        commit('setLocale', locale);
                        resolve(true);
                }).catch((err) => reject(err));
            } else reject(new Error('You are no longer logged in.'));
        });
    },
    logout ({getters, commit, dispatch, rootState}) {

        if (getters.apiToken != null) api.logout(getters.apiToken);

        commit('setToken', '');

        // Wipe the data in the other stores
        dispatch('resetAuthState', {}, {root: true});
        dispatch('resetBroadcastsState', {}, {root: true});
        dispatch('resetMessagesState', {}, {root: true});
        dispatch('resetProgramsState', {}, {root: true});
        dispatch('resetSurveysState', {}, {root: true});
        dispatch('resetUsersState', {}, {root: true});
    },
    resetAuthState({commit}) {
        commit('resetState');
    }
};

const mutations = {
    setToken: (state, token) => {
        Vue.set(state, 'token', token);
        if (!!state.token) localStorage.setItem('api_token_client', state.token);
        else localStorage.removeItem('api_token_client');
    },
    setCurrentUser: (state, user) => {
        Vue.set(state, 'user', user);
    },
    setLocale: (state, locale) => {
        Vue.set(state, 'locale', locale);
    },
    resetState ( state ) {
        const s = initialState();
        Object.keys(s).forEach(key => {
            Vue.set(state, key, s[key]);
        });
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
